(() => {
  const instances = new WeakMap();
  const faqInstances = new WeakMap();
  const ctaSelector = '[data-cv-lorex-p03-final-cta]';
  const faqSelector = '[data-cv-lorex-p03-faq]';

  function initFaq(list) {
    if (faqInstances.has(list)) return;
    const abort = new AbortController();
    list.addEventListener('toggle', (event) => {
      if (!(event.target instanceof HTMLDetailsElement) || !event.target.open || list.dataset.multiple === 'true') return;
      list.querySelectorAll('details[open]').forEach((item) => {
        if (item !== event.target) item.open = false;
      });
    }, { capture: true, signal: abort.signal });
    faqInstances.set(list, abort);
  }

  function initFinal(cta) {
    instances.get(cta)?.destroy();
    const purchase = [...document.querySelectorAll('[data-cv-lorex-p03-controller]')]
      .find((node) => node.dataset.productId === cta.dataset.productId);
    const form = purchase?.querySelector('[data-cv-lorex-p03-product-form]');
    const variantInput = purchase?.querySelector('[data-cv-lorex-p03-variant-input]');
    const button = cta.querySelector('[data-cv-lorex-p03-final-add]');
    if (!purchase || !form || !variantInput || !button) return;
    const abort = new AbortController();
    let variants = [];
    try { variants = JSON.parse(purchase.querySelector('[data-cv-lorex-p03-variants]')?.textContent || '[]'); } catch (_) { return; }
    const price = cta.querySelector('[data-cv-lorex-p03-final-price]');
    const sku = cta.querySelector('[data-cv-lorex-p03-final-sku]');
    const title = cta.querySelector('[data-cv-lorex-p03-final-variant]');
    const status = cta.querySelector('[data-cv-lorex-p03-final-status]');
    const initialStatus = status?.textContent || '';
    const quantity = cta.querySelector('[data-cv-lorex-p03-final-quantity]');
    const sync = () => {
      if (abort.signal.aborted) return;
      const nativeQuantity = form.querySelector('[data-cv-lorex-p03-quantity]');
      if (quantity) quantity.textContent = nativeQuantity?.value || '';
      const variant = variants.find((item) => String(item.id) === String(variantInput.value));
      const main = purchase.querySelector('[data-cv-lorex-p03-add]');
      const busy = main?.getAttribute('aria-busy') === 'true';
      if (price) price.textContent = variant?.priceFormatted || '';
      if (sku) sku.textContent = variant?.sku || '';
      if (title) title.textContent = variant?.title === 'Default Title' ? '' : variant?.title || '';
      button.disabled = busy || !variant?.available;
      button.setAttribute('aria-disabled', String(button.disabled));
      button.setAttribute('aria-busy', String(busy));
      if (status) status.textContent = busy ? cta.dataset.addingLabel || '' : initialStatus;
    };
    const syncAfterNativeUpdate = () => queueMicrotask(sync);
    const onQuantity = (event) => {
      if (event.target.matches?.('[data-cv-lorex-p03-quantity]')) syncAfterNativeUpdate();
    };
    form.addEventListener('input', onQuantity, { signal: abort.signal });
    form.addEventListener('change', onQuantity, { signal: abort.signal });
    variantInput.addEventListener('change', syncAfterNativeUpdate, { signal: abort.signal });
    window.addEventListener('cv-lorex-p03:variant-change', (event) => {
      if (String(event.detail?.productId) === String(cta.dataset.productId)) sync();
    }, { signal: abort.signal });
    const observer = new MutationObserver(sync);
    observer.observe(purchase, { attributes: true, attributeFilter: ['aria-busy', 'disabled'], subtree: true });
    instances.set(cta, { destroy() { abort.abort(); observer.disconnect(); } });
    sync();
  }

  function initialize() {
    document.querySelectorAll(faqSelector).forEach(initFaq);
    document.querySelectorAll(ctaSelector).forEach(initFinal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ctaSelector).forEach((node) => { instances.get(node)?.destroy(); instances.delete(node); });
    event.target.querySelectorAll(faqSelector).forEach((node) => { faqInstances.get(node)?.abort(); faqInstances.delete(node); });
  });
})();
